import React from "react";
import Header from "../components/Header";
import "../styles/NotFound.css";
import { Helmet } from "react-helmet";

const NotFound = () => {

    const FriendlyGhost = () => {
        return (
            <div className="ghost__container">
                <div className="container__elements">
                    <div className="ghost">
                        <div className="ghost__eyes"></div>
                        <div className="ghost__feet">
                            <div className="ghost__feet-foot"></div>
                            <div className="ghost__feet-foot"></div>
                            <div className="ghost__feet-foot"></div>
                            <div className="ghost__feet-foot"></div>
                        </div>
                    </div>
                    <div className="ghost_shadow"></div>
                </div>
            </div>
        )
    }

    const navLinks = [
        { to: "/", label: "Home" },
        { to: "/blog", label: "Our Blog" },
        { to: "/get-in-touch", label: "Support" },
    ];

    return (
        <>
        <header>
            <Header links={navLinks} />
        </header>
        <Helmet>
        <title>Page Not Found | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div>
            <header className="NotFound-header">
                {FriendlyGhost()}
                <p className="Subheading-1"
                    style={{
                        color: "white"
                    }}>
                    Looks like you've found a page that doesn't exist
                </p>

                <a href="/"
                    style={{
                        textDecoration: "none",
                        color: "black",
                        fontSize: "1.2em",
                        textAlign: "center"
                    }}
                >
                    <div className='Message-box'>
                        Click here to go back to safety
                    </div>
                </a>

            </header>
        </div >
        </>
    );
};

export default NotFound;
